export default __webpack_public_path__ + "static/media/bonus_cell.543ff971.png";